module.exports = __webpack_public_path__ + "media/images/new_home/video-poster-31e873a2f84615558da5ca73534ad4d3.png";